import { chakra, Table, Td, Th } from "@chakra-ui/react";
import { fonts } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

const borderStyle = `1px solid ${colours.secondary.deep}`;

export const TableHead = chakra(Th, {
  baseStyle: {
    fontSize: -2,
    lineHeight: -1,
    fontFamily: fonts.acuminLight,
    padding: 1,
    width: "7.3rem",
    textTransform: "none",
    color: colours.primary.dark,
    textAlign: "center",
    borderBottom: borderStyle,
    borderRight: borderStyle,
    border: "solid 1px #fab",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap"
  }
});

export const Cell = chakra(Td, {
  baseStyle: {
    border: "solid 1px #fab",
    width: "100px",
    wordWrap: "break-word",
    textAlign: "center",
    padding: 1
  }
});

export const SizesTable = chakra(Table, {
  baseStyle: {
    borderCollapse: "collapse",
    tableLayout: "fixed",
    width: "310px"
  }
});
